<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        企业报警汇总
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open':  !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.dateRange">
            <el-date-picker
              v-model="slotForms.forms.dateRange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              :picker-options="datePickerOptions"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.comparyName">
            <el-input
              v-model="slotForms.forms.comparyName"
              placeholder="企业名称"
              clearable
            ></el-input>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @sort-change="sortTable"
      >
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <template v-for="(item, index) in tableColumns">
          <el-table-column
            v-if="
              item.columCode == 'alarmNumByStorage' ||
                item.columCode == 'alarmNumByStore' ||
                item.columCode == 'alarmNumByVehicle'
            "
            :key="item.comparyName + '-' + index"
            :prop="item.columCode"
            :label="item.columName"
            :sortable="item.sorted"
            min-width="130"
            header-align="center"
            align="right"
          >
            <template slot-scope="scope">
              <span
                class="links"
                @click="gotoDetail(scope.row, item.columCode)"
                >{{
                  item.columCode == "alarmNumByStorage"
                    ? scope.row.alarmNumByStorage
                    : item.columCode == "alarmNumByStore"
                    ? scope.row.alarmNumByStore
                    : scope.row.alarmNumByVehicle
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item.columCode == 'comparyName'"
            :key="item.comparyName + '-' + index"
            :show-overflow-tooltip="true"
            :prop="item.columCode"
            :label="item.columName"
            min-width="130"
            header-align="center"
            align="left"
            :sortable="item.sorted"
          >
          </el-table-column>
          <el-table-column
            v-else
            :key="item.comparyName + '-' + index"
            :show-overflow-tooltip="true"
            :prop="item.columCode"
            :label="item.columName"
            min-width="240"
            header-align="center"
            align="right"
            sortable="custom"
          >
          </el-table-column>
        </template>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
  </div>
</template>

<script>
import {
  CollectFetchFindByPage,
  exportListByCollect,
  FetchTableColumn
} from "@/api/alarm/comparyAlarm";
import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";
import { datePickerOptionsNotContainToday } from "@/utils/dateUtil.js";
import { exportXlsx } from "@/utils/exportXlsx.js";
import moment from "moment";

export default {
  mixins: [resizeListener, operationManage],
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: false,
      formExtend: {
        forms: {
          dateRange: [],
          comparyName: "",
          sortColumnName: "", //排序列名code
          sortType: 0 //排序方式 1-正序 2-倒序
        },
        extends: []
      },
      formsExtend: [],
      tableData: [],
      loading: "false",
      datePickerOptions: datePickerOptionsNotContainToday,
      //导出URL
      exportUrl: "/report/alarmSummary/exportComparyAlarmSummary?",
      //表格列设置
      tableColumns: [] //表头数据
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"]),
    columnStr() {
      let columnStr = this.copyShowTableCols.map(item => {
        return item.name;
      });
      return columnStr.length < 1 ? "" : columnStr.join(",");
    }
  },
  created() {
    // 条件查询时间范围恢复默认值-今天
    this.formExtend.forms.dateRange = [
      moment()
        .subtract(1, "day")
        .startOf("day")
        .toDate(),
      moment()
        .subtract(1, "day")
        .endOf("day")
        .toDate()
    ];

    // 查询列表数据
    this.FetchFindByPage(this.mergeObj());
    // 获取表格列设置
    this.FetchGetTableColumnSettings({
      moduleId: this.moduleId,
      userId: this.userId
    });
    this.setSearchFormIsOpenAct();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 检验时间40天 && 时间不能为空
    validataTime() {
      let start = moment(this.formExtend.forms.dateRange[0]);
      let end = moment(this.formExtend.forms.dateRange[1]);
      //判断时间间隔不能大于40天
      if (end.diff(start, "days") > 39) {
        this.$message.warning("开始时间与结束时间间隔不能大于40天！");
        return false;
      } else {
        return true;
      }
    },
    // 获取表格数据
    FetchFindByPage(response) {
      if (!response.dateRange) {
        this.$message.warning("开始时间与结束时间不能为空！");
        return false;
      }
      if (this.validataTime()) {
        this.loading = true;
        response.beginTime = moment(response.dateRange[0])
          .startOf("day")
          .valueOf();
        response.endTime = moment(response.dateRange[1])
          .endOf("day")
          .valueOf();
        delete response.dateRange;
        CollectFetchFindByPage(response)
          .then(response => {
            if (
              response.result &&
              response.result.data &&
              Array.isArray(response.result.data)
            ) {
              this.tableData = response.result.data;
              this.total = response.result.totalRecords;
            }
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
      }
    },
    // 获取表格列头
    FetchGetTableColumnSettings(response) {
      FetchTableColumn(response)
        .then(response => {
          if (
            response.code === 1 &&
            response.result &&
            Array.isArray(response.result)
          ) {
            let tableCol = response.result;
            tableCol.forEach(item => {
              if (item.sorted) {
                item.sorted = "custom";
              }
            });
            this.tableColumns = tableCol;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    sortTable({ order = "", prop = "" }) {
      if (!order) {
        this.formExtend.forms.sortType = 0;
        this.formExtend.forms.sortColumnName = "";
      } else {
        this.formExtend.forms.sortType = order == "ascending" ? 2 : 1;
        this.formExtend.forms.sortColumnName = prop;
      }
      this.FetchFindByPage(this.mergeObj());
    },
    // 导出excel 表格
    handleExport() {
      if (this.validataTime()) {
        let params = this.searchData;
        this.exportData(params);
      }
    },
    // 导出页面数据接口请求
    async exportData(params) {
      try {
        exportListByCollect(params).then(res => {
          // 导出
          exportXlsx(res, `企业报警汇总.xls`);
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 跳转明细页面
    gotoDetail(data, type) {
      let path = "";
      if (type == "alarmNumByStorage") {
        path = "/comparyAlarmDetail";
      }
      if (type == "alarmNumByStore") {
        path = "/alarmStoreAlarmDetail";
      }
      if (type == "alarmNumByVehicle") {
        path = "/alarmChillCarAlarmDetail";
      }
      this.$router.push({
        path: path,
        query: {
          comparyName: data.comparyName,
          beginTime: moment(this.formExtend.forms.dateRange[0])
            .startOf("day")
            .valueOf(),
          endTime: moment(this.formExtend.forms.dateRange[1])
            .endOf("day")
            .valueOf()
        }
      });
    },
    //导出
    handleExportClick() {
      let param = "";
      if (
        this.formExtend.forms.dateRange !== null &&
        this.formExtend.forms.dateRange !== ""
      ) {
        param +=
          "&beginTime=" +
          moment(this.formExtend.forms.dateRange[0])
            .startOf("day")
            .valueOf();
        param +=
          "&endTime=" +
          moment(this.formExtend.forms.dateRange[1])
            .endOf("day")
            .valueOf();
        param += "&comparyName=" + this.formExtend.forms.comparyName;
        param += "&sortColumnName=" + this.formExtend.forms.sortColumnName;
        param += "&sortType=" + this.formExtend.forms.sortType;
        document.location.href = this.exportUrl + param;
      } else {
        this.$message({
          showClose: true,
          message: "开始时间与结束时间不能为空！",
          type: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0000ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}
</style>
